<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <b>LA Labor Trafficking Tool</b>
                <router-link v-if="isAllowedToCreateOrEditPerson" :to="addLaborScreeningLink">
                    <b-button type="button" variant="outline-primary" size="sm" class="float-right">
                        <span class="button-text">Add Screening</span>
                    </b-button>
                </router-link>
                <b-button type="button" v-else disabled variant="outline-primary" size="sm" class="float-right">
                    <span class="button-text">Add Screening</span>
                </b-button>
            </b-card-header>
            <div v-if="laborScreenings.length > 0">
                <b-list-group
                    v-for="ls in laborScreenings"
                    :key="ls.id"
                    flush
                >
                    <b-list-group-item>
                        <router-link :to="`/laborscreening/${ls.id}/view/conclusion`">
                            {{$moment(ls.createdAt).format('MM/DD/YYYY')}} {{ls.id}}
                            <img
                                class="ls-icon"
                                v-if="ls.conclusion === LABOR_SCREENING_CONCLUSION.LEVEL1"
                                src="/static/img/ConcernPossible.png"
                                height="21"
                                width="21"
                            />
                            <img
                                class="ls-icon"
                                v-if="ls.conclusion === LABOR_SCREENING_CONCLUSION.LEVEL2"
                                src="/static/img/ConcernDanger.png"
                                height="21"
                                width="21"
                            />
                            <img
                                v-if="lsIsShared(ls)"
                                :src="'/static/img/shareYes.png'"
                                height="21"
                                width="21"
                            >
                        </router-link>
                    </b-list-group-item>
                </b-list-group>
                <router-link :to="'/person/' + personId + '/edit?tabIndex=1'" v-if="isAllowedToCreateOrEditPerson">
                    <b-button
                        type="button"
                        variant="danger"
                        size="md"
                        class="mb-3"
                        style="margin-left: 1.25rem;"
                    >
                        <span class="button-text">Update Victim Status</span>
                    </b-button>
                </router-link>
            </div>
            <div v-else>
                <b-list-group flush>
                    <b-list-group-item>
                        <p>
                            No Labor Screenings
                        </p>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { LABOR_SCREENING_CONCLUSION } from '../../helpers/enums'

export default {
    name: 'ShareLaborScreening',

    props: {
        laborScreenings: {
            type: Array,
            default () {
                return []
            }
        },
        isAllowedToCreateOrEditPerson: {
            type: Boolean,
            default: false
        },
        personId: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            LABOR_SCREENING_CONCLUSION
        }
    },

    computed: {
        ...mapGetters({
            sharePersonRecords: 'sharePersonRecords'
        }),

        addLaborScreeningLink () {
            return `/laborscreening/${this.personId}/add`
        }
    },

    methods: {
        lsIsShared () {
            return this.sharePersonRecords.length
            // const records = ls.sharingRecords
            // const hasRecords = !_.isEmpty(records)
            // if (!hasRecords) {
            //     return false
            // }

            // const active = records.filter((ls) => ls.laborScreeningShareStatus)
            // return active.length > 0
        }
    }
}
</script>

<style>
.ls-icon {
    margin-left: 3px;
    position: relative;
    top: -1px;
}
</style>


// WEBPACK FOOTER //
// src/components/LaborScreening/ShareLaborScreening.vue